import { useEffect } from "react"
import { useContextSelector } from "use-context-selector"

import { AppContext } from "domain/application/AppContext"
import { appSelectors } from "domain/application/selectors"

export const useTitle = (title) => {
  const update = useContextSelector(AppContext, appSelectors.update)

  useEffect(() => {
    update({
      title,
    })
  }, [update])

  return null
}
